import React from 'react'
import styles from './ChooseDeviceStep.scss'
import {OrderedMap} from 'immutable'
import {S2DLayout} from '../S2DLayout'
import {RadioButtonGroup} from 'common/styleguide/RadioGroup'
import cx from 'classnames'

export const devices = OrderedMap({
  iphone: 'iPhone',
  android: 'Android',
  garmin: 'Garmin Edge',
  wahoo: 'Wahoo'
})

export class ChooseDeviceStep extends React.PureComponent {
  render () {
    const {route, routeId, subtitle, selectedDevice, onChangeDevice, onConfirmDevice} = this.props
    return (
      <S2DLayout
        title='Send to Device'
        subtitle={subtitle}
        step={1}
        onClickNext={() => onConfirmDevice()}
        disableNext={!selectedDevice && 'Please choose a device to continue'}>
        <div className={styles.ChooseDeviceStep}>
          <div className={styles.columns}>
            <div className={cx(styles.column, styles.mapCol)}>
              <RenderedStaticMap route={route} routeId={routeId} />
            </div>
            <div className={styles.column}>
              <p>Select a device</p>
              <RadioButtonGroup
                selected={selectedDevice}
                options={devices}
                onChange={onChangeDevice} />
              <div>or <a onClick={() => onConfirmDevice('other')}>Other Device</a></div>
            </div>
          </div>
        </div>
      </S2DLayout>
    )
  }
}

class RenderedStaticMap extends React.PureComponent {
  render () {
    const {routeId, route} = this.props
    return (
      <div className={styles.RenderedStaticMap}>
        <img className={styles.mapImg} src={`/routes/light/${routeId}.png`} />
        <div className={styles.scrim}>
          <div className={styles.label}>
            <div className={styles.routeName}>{route && route.name}</div>
            <div className={styles.routeAuthor}>{route && route.user.name}</div>
          </div>
        </div>
      </div>
    )
  }
}
